import Vue from 'vue'
import App from './App'
import router from './router'
//import vconsole from '@/utils/vconsole' // eslint-disable-line
import VConsole from 'vconsole'
import dsbridge from '@/utils/dsbridge'
import wx from 'weixin-js-sdk'
import 'babel-polyfill'
import '../node_modules/swiper/dist/css/swiper.min.css'
import 'normalize.css'
import './components'

import './assets/styles/common.less'
import filters from './filters'
import store from './store'
import VueBarcode from 'vue-barcode';
import { Row, Col, Collapse, CollapseItem, TreeSelect, NavBar, Tab, Tabs, Cell, CellGroup, Checkbox, PasswordInput, NumberKeyboard, Icon, RadioGroup, Radio, Area, Popup, DatetimePicker, Toast, ImagePreview, Uploader, List, Rate, Button, PullRefresh, Field, Dialog, Loading } from 'vant'

Object.keys(filters).forEach(k => Vue.filter(k, filters[k]))
Vue.component('barcode', VueBarcode);
Vue.use(require('vue-wechat-title'))
Vue.use(dsbridge)
const FastClick = require('@/../static/js/fastclick.js')
FastClick.attach(document.body)
Vue.use(Row).use(Col).use(Collapse).use(CollapseItem).use(TreeSelect).use(NavBar).use(Tab).use(Tabs).use(Cell).use(CellGroup).use(Checkbox).use(PasswordInput).use(NumberKeyboard).use(Icon).use(RadioGroup).use(Radio).use(Area).use(Popup).use(DatetimePicker).use(Toast).use(ImagePreview).use(Uploader).use(List).use(Rate).use(Button).use(PullRefresh).use(Field).use(Dialog).use(Loading)
require('es6-promise').polyfill()
Vue.config.productionTip = false
Vue.prototype.wx = wx
Vue.prototype.getStorage = localStorage.getItem

/* eslint-disable no-new */

const vconsole = new VConsole({
  onReady: () => {
    //if(process.env.NODE_ENV == 'production'){
      vconsole.hideSwitch()
    //}
  }
})
Vue.prototype.$vconsole = vconsole

export default new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js